import { render } from "./AddUserReportDescription.vue?vue&type=template&id=c47ad484&scoped=true"
import script from "./AddUserReportDescription.vue?vue&type=script&lang=js"
export * from "./AddUserReportDescription.vue?vue&type=script&lang=js"

import "./AddUserReportDescription.vue?vue&type=style&index=0&id=c47ad484&lang=less&scoped=true"

import exportComponent from "/Users/kacper/IdeaProjects/e.on-portal-awarie/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c47ad484"]])

export default __exports__